<script lang="ts">
	import { PrimaryBtnColors } from '../atoms/PrimaryButton.svelte'
	import Tooltip from '../atoms/Tooltip.svelte'
	import { TooltipPlacements } from '$types/enums'
	import IconNeutral from '$svg/icon_pen_shape_outline.svg?component'
	import IconPositive from '$svg/icon_checkmark_bold.svg?component'
	import IconNegative from '$svg/icon-cross.svg?component'
	import { OfferReactionButtons } from '#lib/bid/types/offer.js'
	import Button from '#lib/atoms/Button.svelte'

	interface Props {
		label?: string
		reaction?: OfferReactionButtons
		tooltipMsg?: string
		disabled?: boolean
		onReactionBtnClick?: () => void
	}

	let {
		label = '',
		reaction = OfferReactionButtons.POSITIVE,
		tooltipMsg = '',
		disabled = false,
		onReactionBtnClick
	}: Props = $props()
	let color = $derived(getColorForReaction(reaction))

	function getColorForReaction(reaction: OfferReactionButtons) {
		if (reaction === OfferReactionButtons.POSITIVE) {
			return PrimaryBtnColors.GREEN
		} else if (reaction === OfferReactionButtons.NEUTRAL) {
			return PrimaryBtnColors.ORANGE
		} else if (reaction === OfferReactionButtons.NEGATIVE) {
			return PrimaryBtnColors.RED
		}
	}

	function clickEvent() {
		if (!disabled && onReactionBtnClick) {
			onReactionBtnClick()
		}
	}

	const iconBackgroundColor = $derived.by(() => {
		switch (reaction) {
			case OfferReactionButtons.POSITIVE:
				return 'var(--primary-green)'
			case OfferReactionButtons.NEUTRAL:
				return 'var(--color-orange-500)'
			case OfferReactionButtons.NEGATIVE:
				return 'var(--color-red-500)'
		}
	})
</script>

<div
	class="offer-reaction-container"
	class:positive-container={reaction === OfferReactionButtons.POSITIVE}
	class:negative-container={reaction === OfferReactionButtons.NEGATIVE}
	class:neutral-container={reaction === OfferReactionButtons.NEUTRAL}
	class:tt={tooltipMsg !== ''}
	class:disabled
>
	{#if tooltipMsg !== ''}
		<div class="top-right">
			<Tooltip msg={tooltipMsg} placementTtip={TooltipPlacements.TOP_END} />
		</div>
	{/if}
	<button
		type="button"
		aria-label={label || 'Reaktion auf Angebot'}
		{disabled}
		class="offer-reaction-icon"
		class:disabled
		style="background-color: {iconBackgroundColor}"
		onclick={clickEvent}
	>
		{#if reaction === OfferReactionButtons.POSITIVE}
			<IconPositive width={24} height={24} />
		{:else if reaction === OfferReactionButtons.NEUTRAL}
			<IconNeutral width={24} height={24} />
		{:else if reaction === OfferReactionButtons.NEGATIVE}
			<IconNegative width={24} height={24} stroke="#fff" fill="#fff" />
		{/if}
	</button>
	<Button
		variant="primary"
		{color}
		{disabled}
		style="width: 100%; max-width: 255px;"
		onclick={clickEvent}
	>
		<span class="btn-text">{label}</span>
	</Button>
</div>

<style>
	.offer-reaction-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		border: none;
		padding: 2.188em 2.75rem;
		width: 100%;
		border-radius: 4px;
		height: 188px;
	}

	.disabled:hover {
		cursor: default;
		filter: none !important;
	}

	.tt {
		padding: 0.625rem 2.75rem;
	}

	.positive-container {
		background-color: var(--color-green-50);
	}

	.negative-container {
		background-color: var(--color-red-50);
	}

	.neutral-container {
		background-color: var(--color-orange-50);
	}

	.top-right {
		align-self: flex-end;
		right: -2rem;
		position: relative;
		padding-bottom: 10px;
	}

	.offer-reaction-icon {
		border: none;
		width: 56px;
		height: 56px;
		border-radius: 50%;
		margin-bottom: 1.875rem;
		padding: 0.75rem;
		transition: filter 0.5s ease-out;

		&:hover {
			filter: drop-shadow(0 0 0.25rem rgba(0, 0, 0, 0.75));
		}
	}

	.btn-text {
		font-family: Roboto, sans-serif;
		color: #fff;
		text-align: center;
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 18px;
	}
</style>
